import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import Input from '../Input';
import Button from '../Button';
import checkmark from '../OptIn/checkmark.png';

const Box = styled.div`
  padding: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  background-color: ${props => props.theme.personalMessage?.backgroundColor || props.theme.optInButton?.backgroundColor};
  border: ${props => props.theme.personalMessage?.border || props.theme.optInButton?.border};
  border-radius: ${props => props.theme.personalMessage?.borderRadius};

  button {
    margin-top: 21px;

    &:active {
      ${props => props.theme.personalMessage?.active};
    }

    &:focus {
      ${props => props.theme.personalMessage?.focus};
    }

    &:hover {
      ${props => props.theme.personalMessage?.hover};
    }
  }
`;
const Label = styled.div`
  width: 100%;
  height: auto;
  line-height: 32px;
  font-family: ${props => props.theme.personalMessage?.fontFamily || props.theme.optInButton?.fontFamily};
  font-size: ${props => props.theme.personalMessage?.fontSize || props.theme.optInButton?.fontSize};
  font-style: normal;
  letter-spacing: 0.6px;
  text-align: left;
  color: ${props => props.theme.personalMessage?.color || props.theme.optInButton?.color};
  box-shadow: ${props => props.theme.personalMessage?.boxShadow || props.theme.optInButton?.boxShadow};
  margin-bottom: ${props => props.theme.personalMessage?.marginBottom || '16px'};
`;
const MessageAdded = styled.div`
  font-family: ${props => props.theme.personalMessage?.fontFamily || props.theme.optInButton?.fontFamily};
  font-size: ${props => props.theme.personalMessage?.fontSize || '31px'};
  color: ${props => props.theme.personalMessage?.checkmarkColor || '#199A57'};
  margin-top: 20px;
  margin-bottom: 20px;

  .checkmark {${props => props.theme.personalMessage?.checkmark || `
    background: url(${checkmark}) no-repeat 0;
    width: 35px;
    height: 20px;
    display: inline-block;
  `}}
`;

function PersonalMessageForm({formContext, isMessageAdded, saveMessage}) {
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');

  const allowMessage = formContext.personalMessageLabel
  const allowName = formContext.personalMessageNameLabel

  const submitMessage = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isMessageEmpty = _.trim(message) === '';
    const isNameEmpty = _.trim(name) === '';

    if (!(isMessageEmpty && isNameEmpty)) {
      saveMessage(formContext.proposition, formContext.pageVariantKey, message, name);
    }
  };

  if (isMessageAdded) {
    return <MessageAdded>
      <span className='checkmark' />Je boodschap is toegevoegd
    </MessageAdded>;
  }

  return <>
    {(allowMessage || allowName) && <Box>
      {allowMessage && <div className='marginBottomTen'>
        <Label>{formContext.personalMessageLabel}</Label>
        <Input
          name='message'
          setValue={value => setMessage(value)}
          value={message}
          placeholder={formContext.personalMessagePlaceholder}
        />
      </div>}
      {allowName && <div>
        <Label>{formContext.personalMessageNameLabel}</Label>
        <Input
          name='name'
          setValue={value => setName(value)}
          value={name}
          placeholder={formContext.personalMessageNamePlaceholder}
        />
      </div>}
      <Button label={'Bericht versturen'} onClick={submitMessage} />
    </Box>}
  </>;
}

PersonalMessageForm.propTypes = {
  isMessageAdded: PropTypes.bool,
  saveMessage: PropTypes.func
};

export default PersonalMessageForm;
